import React, { useState } from "react";
import CountrySelect from "./CountrySelect";
import * as PropTypes from 'prop-types';
import PaymentOptionSelect from "./PaymentOptionSelect";
import PaymentForm from "./PaymentForm";
import PaymentSummary from './PaymentSummary';
import PayerSelect from "./PayerSelect";
import CurrencySelect from "./CurrencySelect";
export default function MassPay(props) {
    const active = props.active;
    const amount = props.amount;
    const [destinationId, setDestinationId] = useState("");
    const [country, setCountry] = useState({
        code: "",
        name: "",
        three_letter_code: "",
        iso_numeric: 0
    });
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [paymentPayer, setPaymentPayer] = useState(null);
    const [paymentCurrency, setPaymentCurrency] = useState(null);
    if (active === 2) {
        return <CountrySelect
            {...props}
            country={country}
            setCountry={setCountry}
            amount={amount}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            setDestinationId={setDestinationId}
            setPaymentCurrency={setPaymentCurrency}
            setPaymentPayer={setPaymentPayer}
        />;
    }

    if (active === 3) {
        return <PaymentOptionSelect
            {...props}
            country={country}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            setPaymentCurrency={setPaymentCurrency}
            setPaymentPayer={setPaymentPayer}
            paymentCurrency={paymentCurrency}
            paymentPayer={paymentPayer}
            setDestinationId={setDestinationId}
            amount={amount} />
    }

    if (active === 4) {
        return <PayerSelect
            {...props}
            country={country}
            paymentMethod={paymentMethod}
            setPaymentCurrency={setPaymentCurrency}
            setPaymentPayer={setPaymentPayer}
            paymentCurrency={paymentCurrency}
            paymentPayer={paymentPayer}
            setDestinationId={setDestinationId}
            amount={amount} />;
    }

    if (active === 5) {
        return <CurrencySelect
            {...props}
            country={country}
            paymentMethod={paymentMethod}
            setPaymentCurrency={setPaymentCurrency}
            setPaymentPayer={setPaymentPayer}
            paymentCurrency={paymentCurrency}
            paymentPayer={paymentPayer}
            setDestinationId={setDestinationId}
            amount={amount} />;
    }

    if (active === 6) {
        return <PaymentForm
            {...props}
            country={country}
            paymentMethod={paymentMethod}
            destinationId={destinationId}
            amount={amount}
            paymentCurrency={paymentCurrency}
            paymentPayer={paymentPayer}
            setDestinationId={setDestinationId} />
    }
    if (active === 7) {
        return <PaymentSummary
            {...props}
            country={country}
            paymentCurrency={paymentCurrency}
            paymentPayer={paymentPayer}
            paymentMethod={paymentMethod}
            amount={amount}
            destinationId={destinationId} />
    }
    return <></>
}

MassPay.propTypes = {
    amount: PropTypes.any,
    setActive: PropTypes.func,
    active: PropTypes.number,
    setShowKytBlocked: PropTypes.func,
    setShowKyt: PropTypes.func
}